import React, { Component } from 'react';
import ReactPlayer from 'react-player'

export default function VideoPlayer(props) {

  return <ReactPlayer  {...props} />

}